<template>
  <!-- Page Sections -->
  <div class="w3-content w3-padding" style="max-width:1564px">
    <Events />
    <Sound />
    <About />
    <!-- <Contact /> -->
    <!--Location /-->
  </div>
</template>

<script>
import Events from "@/components/section/Events.vue";
import Sound from "@/components/section/Sound.vue";
import About from "@/components/section/About.vue";
// import Contact from "@/components/section/Contact.vue";
// import Location from "@/components/section/Location.vue";

export default {
  name: "content",
  components: {
    Events,
    Sound,
    About
    // Contact
    // Location
  }
};
</script>

<style></style>
